import styled from 'styled-components'

 export const NavWrap = styled.nav`
    background: var(--mainBlue);
    .nav-link{
        color:var(--mainWhite)!important;
        font-size: 1.3rem;
        text-transform: capitalize;

    }


 `;